'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ConsultationCTAProps {
  title: string;
  description: string;
  buttonText: string;
  onButtonClick: () => void;
}

const ConsultationCTA: React.FC<ConsultationCTAProps> = ({
  title,
  description,
  buttonText,
  onButtonClick,
}) => {
  return (
    <div className="bg-gradient-to-r from-primary to-navy-dark rounded-lg shadow-elevation-md p-8 md:p-12 text-center">
      <div className="max-w-3xl mx-auto">
        <div className="w-20 h-20 bg-accent rounded-full flex items-center justify-center mx-auto mb-6">
          <Icon name="ScaleIcon" size={40} className="text-primary" />
        </div>
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4">{title}</h2>
        <p className="text-white/90 text-lg mb-8 leading-relaxed">{description}</p>
        <button
          onClick={onButtonClick}
          className="px-10 py-4 bg-gradient-to-r from-accent to-gold-dark text-primary font-semibold text-lg rounded-lg shadow-subtle hover:shadow-elevation-sm hover:scale-105 transition-all duration-300 inline-flex items-center space-x-3"
        >
          <span>{buttonText}</span>
          <Icon name="CalendarIcon" size={24} />
        </button>
        <div className="mt-8 flex items-center justify-center space-x-8 text-white/80">
          <div className="flex items-center space-x-2">
            <Icon name="ClockIcon" size={20} />
            <span className="text-sm">24-Hour Response</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="ShieldCheckIcon" size={20} />
            <span className="text-sm">Confidential</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="CheckCircleIcon" size={20} />
            <span className="text-sm">No Obligation</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsultationCTA;